import { PasswordBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerResetPasswordStore } from '../state/useBrokerResetPasswordStore';

interface OldPasswordTextBoxProps {
    required?: boolean;
}

export const OldPasswordTextBox: React.FC<OldPasswordTextBoxProps> = ({ required = false }) => {
    const isMobile = isMobileScreen();
    const label = 'Old Password';
    const value = useBrokerResetPasswordStore((s) => s.passwordResetInfo.password);
    const setValue = useBrokerResetPasswordStore((s) => s.set_password);

    return (
        <>
            <PasswordBox
                id='oldPasswordBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width={isMobile ? '100%' : 'auto'}
            />
        </>
    );
};
